import { useNavigate } from 'react-router-dom';
import { Card, CardBody, Button, Alert } from 'reactstrap';
import { useAuth } from '../auth/AuthProvider';

export function NoAccessPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const isZitadel = auth.mode === 'zitadel';

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <Card style={{ maxWidth: 560 }}>
        <CardBody>
          <h2 className="mb-3 text-center">Kein Operator-Zugriff</h2>
          <p className="text-muted">
            Dieses Konto hat keine Membership in einer Brand mit{' '}
            <code>staff</code>- oder <code>admin</code>-Rolle.
          </p>

          {isZitadel && (
            <Alert color="info" className="small">
              <strong>Erstmaliger Login?</strong> Dein Zitadel-Login wurde erkannt
              und ein Operator-Account angelegt, aber dir wurde noch keine Brand
              zugewiesen. Bitte melde dich beim Operator-Admin
              (<a href="mailto:admin@valitype.com">admin@valitype.com</a>) und
              nenne deinen Zitadel-User-Namen — du wirst dann zu den passenden
              Brands hinzugefügt.
            </Alert>
          )}

          <div className="text-center mt-3">
            <Button
              color="secondary"
              onClick={() => {
                auth.signOut();
                navigate('/login', { replace: true });
              }}
            >
              Abmelden
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
